<template>
  <div>
    <div
      class="couponBox"
      :class="{ notUnused: actind !== 0 }"
      :style="{ backgroundImage: `url(${actind !== 0 ? couponBg1 : couponBg0})` }"
      v-for="(item, ind) in couponList"
      :key="ind"
    >
      <!-- pos -->
      <p class="posLT" v-if="item.fitUser !== 1">
        {{ item.fitUser === 2 ? '新用户专享' : item.fitUser === 3 ? '老用户专享' : '' }}
      </p>
      <div class="couponLeft">
        <p class="pic" v-if="item.discountType === 1">
          <i>￥</i>
          {{ item.discountAmount }}
        </p>
        <p class="pic" v-else>
          {{ item.discountAmount }}
          <i>折</i>
        </p>
        <p class="tip">满{{ item.usableCondition }}可用</p>
      </div>
      <div class="couponRight">
        <p class="couponTitle ellipsis">
          <i v-if="item.frontEndName.substr(0, 1) == '【'" class="title-special-processing" />
          {{ item.frontEndName }}
        </p>
        <p class="tipR">{{ showType(item.productionFitType,item.packageFitType) }}</p>
        <p class="time" v-if="actind !== 0">
          {{ Format2(item.effectiveTimeBegin) }}-{{ Format2(item.effectiveTimeEnd) }}
        </p>
        <div v-else>
          <div v-if="item.effectiveTimeType === 2">
            <p class="time">
              {{ Format2(item.effectiveTimeBegin) }}-{{ Format2(item.effectiveTimeEnd) }}
            </p>
          </div>
          <div v-else>
            <p class="time">仅剩：{{ item.countDown }}</p>
          </div>
        </div>
      </div>
      <template v-if="actind == 0">
        <div class="immediateFath">
          <div class="immediateUse" @click="immediateUseBtn(item)">立即使用</div>
        </div>
      </template>
      <img v-if="actind !== 0" class="posImg" :src="actind === 1 ? usedIcon : expiredIcon" alt />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqCouponList } from '@/api/personal';
import { dateTime, replaceHyphens, setBaseUrl, timerYhqCount } from '@/utils/tools';
import moment from 'moment';

function InitTime(endtime) {
  let hh = null;
  let mm = null;
  let ss = null;
  const time = parseInt(endtime, 0) - new Date().getTime();
  if (time <= 0) {
    return '到期倒计时：00 : 00 : 00';
  }
  hh = Math.floor((time / 60 / 60) % 24);
  mm = Math.floor((time / 60) % 60);
  ss = Math.floor(time % 60);
  const str = `到期倒计时：${hh.toString().padStart(2, '0')} : ${mm
    .toString()
    .padStart(2, '0')} : ${ss.toString().padStart(2, '0')}`;
  return str;
}
export default {
  props: {
    // 0未使用 1已使用 2已过期
    actind: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      list: [],
      couponBg0: require('./img/couponBg0.png'), // 未使用背景图
      couponBg1: require('./img/couponBg1.png'), // 非未使用背景图
      usedIcon: require('./img/usedIcon.png'), // 已使用
      expiredIcon: require('./img/expiredIcon.png'), // 已过期
      couponList: [],
      currentTime: new Date().getTime(),
      timers: null, // 定时器
    };
  },

  computed: {
    ...mapState(['userInfo']),
  },
  created() {},
  mounted() {
    this.getCouponList();
  },
  watch: {
    userInfo: {
      deep: true,
      handler() {
        this.getCouponList();
      },
    },
    actind() {
      this.couponList = [];
      this.getCouponList();
    },
  },
  methods: {
    async getCouponList() {
      const userId = this.userInfo.id;
      if (userId) {
        const res = await reqCouponList({
          couponStatus: this.actind === 2 ? 4 : this.actind + 1, // 1 已领取未使用 2 已使用 3 已过期
          pageNum: 1,
          pageSize: 100,
          userId,
        });
        if (res.data.data && res.data.data.length <= 0) {
          this.$parent.isCouponList = false;
        } else {
          this.$parent.isCouponList = true;
        }
        this.currentTime = res?.currentTime
          ? new Date(replaceHyphens(res.currentTime)).getTime()
          : new Date().getTime();
        this.couponList = res.data.data;
        if (this.actind === 0) {
          this.getTimeList(this.couponList);
        } else if (this.timers) clearInterval(this.timers);
      }
    },

    getTimeList(couponDataList) {
      couponDataList.forEach((item, i) => {
        if ([1,3,4].includes(item.effectiveTimeType)) {
          const endTime = new Date(replaceHyphens(item.expireTime)).getTime();
          let timeDifference;
          if (item.effectiveTimeType === 1) {
            timeDifference = endTime - this.currentTime;
          } else if (item.effectiveTimeType === 3){
            const currentDayEndTiem = moment().endOf('day').valueOf();
            timeDifference = currentDayEndTiem - this.currentTime;
          } else if (item.effectiveTimeType === 4){
            const currentDayEndTiem = moment(item?.expireTime).valueOf();
            timeDifference = currentDayEndTiem - this.currentTime;
          }
          if (timeDifference < 0) {
            this.$set(item, 'countDown', '-');
            return;
          }
          this.timers = setInterval(() => {
            timeDifference -= 1000;
            if (timeDifference > 0) {
              this.$set(item, 'countDown', timerYhqCount(timeDifference));
            } else {
              this.$set(item, 'countDown', '-');
              clearInterval(this.timers);
            }
          }, 1000);
        }
      });
    },

    Format2(date) {
      const dateTimes = dateTime(new Date(replaceHyphens(date)).getTime());
      return `${dateTimes.year}-${dateTimes.month}-${dateTimes.day} ${dateTimes.h}:${dateTimes.m}`;
    },
    showType(type, status) {
      const typeMap = {
        1: '所有产品',
        2: '指定产品可用',
        3: '指定产品可用',
      };
      let text = typeMap[type] || '';
      if (status === 4) {
        text = type === 1 ? '所有产品' : '指定产品可用';
      } else if (status === 5) {
        text = '指定产品可用';
      }
      return text;
    },
    immediateUseBtn(item) {
      const { productionFitType,packageFitType } = item;
      let routeUrl = '';
      // 适用产品类型 1 所有产品 2 限定产品 3 限定产品分类 4 所有套餐 5 限定套餐
      if (productionFitType === 1 || productionFitType === 4|| packageFitType === 4) {
        // 判断是否App
        if (this.$root.$data.isApp) {
          this.$sendToApp('goToHomePage');
          return;
        }
        if (this.$root.miniprogram) {
          this.$toast(
            `此优惠券支持购买小程序中所有${
              productionFitType === 1 ? '产品' : '套餐'
            }。若需购买更多${productionFitType === 1 ? '产品' : '套餐'}，请前往app查看`,
          );
          return;
        }
        this.$router.push({
          path: '/home',
          query: {
            code: 2,
          },
        });
        return;
      }
      if(packageFitType===5&&(productionFitType===2||productionFitType===3)){
         const { productIds ,productCatalogIds,packageIds} = item;
         const productId = productIds?.join();
         const productCategoryId = productCatalogIds?.join();
         const packageId = packageIds?.join();
        if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/limitProduct?productionFitType=${productionFitType}&packageFitType=${packageFitType}&productIds=${productId}&productCategoryIds=${productCategoryId}&packageIds=${packageId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/limitProduct',
            query: {
              productionFitType,
              packageFitType,
              productIds:productId,
              productCategoryIds:productCategoryId,
              packageIds:packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        return
      }
      if (productionFitType === 2) {
        const { productIds } = item;
        if (productIds.length > 1) {
          const productId = productIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/productList?type=5&productId=${productId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/productList',
            query: {
              type: 5,
              productId,
            },
          });
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goCourseDetail', Number(productIds[0]), false);
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/courseDetail',
            query: {
              courseId: productIds[0],
            },
          });
        }
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 3) {
        const { productCatalogIds } = item;
        const productCategoryId = productCatalogIds.join();
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            {
              url: `${setBaseUrl(
                '',
              )}/ark/productList?type=3&productCategoryId=${productCategoryId}`,
            },
            false,
          );
          return;
        }
        routeUrl = this.$router.resolve({
          path: '/productList',
          query: {
            type: 3,
            productCategoryId,
          },
        });
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 5||packageFitType===5) {
        const { packageIds } = item;
        if (packageIds.length > 1) {
          const packageId = packageIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/combinationList?packageIds=${packageId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationList',
            query: {
              packageIds: packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goToCombinationCourse', Number(packageIds[0]), false);
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationCourse',
            query: {
              combinationId: packageIds[0],
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      }
    },
  },
  destroyed() {
    clearInterval(this.timers);
  },
};
</script>

<style lang="scss" scoped>
.couponBox {
  position: relative;
  display: flex;
  clear: both;
  margin-bottom: 29px;
  padding: 14px 0;
  background-size: 100% 100%;
}
.posLT {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 105px;
  height: 32px;
  color: #ff6c02;
  font-size: 18px;
  line-height: 32px;
  text-align: center;
  background: #fff0e6;
  border-radius: 5px 0 7px 0;
}
// 左板块
.couponLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 186px;
  height: 163px;
  // border-right: 2px dashed #eee;
}
.pic {
  color: #ff6c02;
  font-weight: bold;
  font-size: 43px;
  i {
    font-weight: bold;
    font-size: 25px;
    font-style: normal;
  }
}
.tip {
  margin-top: 4px;
  color: #787878;
  font-size: 22px;
  line-height: 31px;
}
// 右板块
.couponRight {
  width: 300px;
  margin-left: 25px;
  padding-top: 14px;
  .couponTitle {
    color: #333;
    font-size: 29px;
    line-height: 36px;
  }
  .tipR {
    margin-top: 14px;
    color: #787878;
    font-size: 22px;
    line-height: 29px;
  }
  .time {
    margin-top: 14px;
    color: #787878;
    font-size: 22px;
    line-height: 29px;
  }
}
.posImg {
  position: absolute;
  right: 36px;
  bottom: 29px;
  width: 101px;
  height: 80px;
}
// 非未使用样式
.notUnused {
  .pic,
  .couponTitle,
  .tipR,
  .time {
    color: #a5a5a5;
  }
}
.immediateFath {
  position: absolute;
  top: 25px;
  right: 40px;
  display: flex;
  justify-content: center;
}
.immediateUse {
  align-self: center;
  width: 56px;
  height: 138px;
  color: #fff;
  font-weight: 500;
  font-size: 22px;
  line-height: 56px;
  letter-spacing: 2px;
  text-align: center;
  background: #ff6c02;
  border-radius: 14px;
  writing-mode: vertical-lr; /* 从左向右 从右向左是 writing-mode: vertical-rl; */
  writing-mode: tb-lr; /* IE浏览器的从左向右 从右向左是 writing-mode: tb-rl； */
}
</style>
